import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { CommonService } from './common.service';
import { environment } from 'src/environments/environment';
import { UserInfoService } from './userInfo.service';
import { catchError, map, tap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BillingService {
    private _refreshNeeded$ = new Subject<void>();
    notifyCount$ = new Subject<number>();
    infoUpdateCount$ = new Subject<number>();
    localBasePath = '/reports';
    commonHeaders = new HttpHeaders({
        'Accept-Version': 'V2',
        'X-Tenant-ID': this.userInfoService.userDetails.tenantID
    });

    constructor(private http: HttpClient,
        private commonService: CommonService,
        readonly userInfoService: UserInfoService
    ) { }

    get refreshNeeded$() {
        return this._refreshNeeded$;
    }

    getInvoice(transactionId): Observable<any> {
        try {
            let headers = { headers: { 'Accept-Version': 'V2' } }
            return this.http.get(environment.API_BASE_PATH + `/reports/invoice/transaction/${transactionId}`, { responseType: 'blob', ...headers }).pipe(map((response: any) => {
                return response;
            }, error => {
                return null;
            }));
        }
        catch (error) {
            return of(null);
        }
    }

    getChargerReportMain(index, rows, column, direction, search) {
        let headers = { headers: { 'Accept-Version': 'V2' } }
        const payload = {
            sortParam: {
                "starting_index": String(index),
                "max_rows": String(rows),
                "sort_by": String(column),
                "sort_dir": String(direction),
                "search": String(search)
            }
        }
        return this.commonService.postCall(environment.API_BASE_PATH + '/reports/cpo-chargebox-status', payload, headers);
    }

    getChargerReportDownload(type): Observable<any> {
        try {
            let headers = { headers: { 'Accept-Version': 'V2' } }
            const payload = {}
            return this.http.post(environment.API_BASE_PATH + `/reports/cpo-chargebox-status/${type}`, payload, { responseType: 'blob', ...headers, observe: 'response' }).pipe(map((response: any) => {
                const result = { body: response.body, headers: response.headers };
                return result;
            }, error => {
                return null;
            }));
        }
        catch (error) {
            return of(null);
        }
    }

    getChargerReportHyperlinkDownload(vendormailid, type): Observable<any> {
        try {
            let headers = { headers: { 'Accept-Version': 'V2' } }
            const payload = { 'cpo_email': String(vendormailid) }
            return this.http.post(environment.API_BASE_PATH + `/reports/cpo-chargeboxes-status/${type}`, payload, { responseType: 'blob', ...headers, observe: 'response' }).pipe(map((response: any) => {
                const result = { body: response.body, headers: response.headers };
                return result;
            }, error => {
                return null;
            }));
        }
        catch (error) {
            return of(null);
        }
    }


    getChargerReportVendor(vendormailid, index, rows, column, direction, search) {
        const payload = {
            sortParam: {
                "starting_index": String(index),
                "max_rows": String(rows),
                "sort_by": String(column),
                "sort_dir": String(direction),
                "search": String(search)
            },
            'cpo_email': String(vendormailid)
        }
        let headers = { headers: { 'Accept-Version': 'V2' } };
        return this.commonService.postCall(environment.API_BASE_PATH + '/reports/cpo-chargeboxes-status', payload, headers);
    }

    getReconcileReport(vendorId, type, startDate?: any, endDate?: any): Observable<any> {
        try {
            let headers = {};
            if (startDate && endDate) {
                headers = {
                    headers: { 'Accept-Version': 'V2' }
                };
            }
            const val = {
                "emails": vendorId.split(','), 'start_date': startDate,
                'end_date': endDate
            }
            return this.http.post(environment.API_BASE_PATH + `/reports/reconcile/${type}`, val, { responseType: 'blob', ...headers, observe: 'response' }).pipe(map((response: any) => {
                const result = { body: response.body, headers: response.headers };
                return result
            }, error => {
                return null;
            }));
        }
        catch (error) {
            return of(null);
        }
    }


    getReconcileList(vendorId, index, rows, column, direction, search, startDate?: any, endDate?: any) {
        const currentDate = new Date();
        const lastMonthDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, currentDate.getDate());
        startDate = startDate ? startDate : lastMonthDate;
        endDate = endDate ? endDate : currentDate;
        const payload = {
            sortParam: {
                "starting_index": String(index),
                "max_rows": String(rows),
                "sort_by": String(column),
                "sort_dir": String(direction),
                "search": String(search)
            },
            "emails": vendorId.split(','),
            "cpo_email": "",
            "start_date": startDate,
            "end_date": endDate
        }
        let headers = { headers: { 'Accept-Version': 'V2' } }
        return this.commonService.postCall(environment.API_BASE_PATH + `/reports/reconcile`, payload, headers);
    }

    getSettlementReport(vendorId, type, startDate?: any, endDate?: any): Observable<any> {
        try {
            let headers = {};
            if (startDate && endDate) {
                headers = {
                    headers: { 'Accept-Version': 'V2' }
                };
            }
            const val = {
                "emails": vendorId.split(','), 'start_date': startDate,
                'end_date': endDate
            }
            return this.http.post(environment.API_BASE_PATH + `/reports/settlement/${type}`, val, { responseType: 'blob', ...headers, observe: 'response' }).pipe(map((response: any) => {
                const result = { body: response.body, headers: response.headers };
                return result
            }, error => {
                return null;
            }));
        }
        catch (error) {
            return of(null);
        }
    }

    getSettlementList(Id, index, rows, column, direction, search, startDate?: any, endDate?: any) {
        const currentDate = new Date();
        const lastMonthDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, currentDate.getDate());
        startDate = startDate ? startDate : lastMonthDate;
        endDate = endDate ? endDate : currentDate;
        const payload = {
            sortParam: {
                "starting_index": String(index),
                "max_rows": String(rows),
                "sort_by": String(column),
                "sort_dir": String(direction),
                "search": String(search)
            },
            "emails": Id.split(','),
            "cpo_email": "",
            "start_date": startDate,
            "end_date": endDate
        }
        let headers = { headers: { 'Accept-Version': 'V2' } }
        return this.commonService.postCall(environment.API_BASE_PATH + `/reports/settlement`, payload, headers);
    }

    updateReport(id, val: any) {
        let headers = { headers: { 'Accept-Version': 'V2' } };
        return this.commonService.putCall(environment.API_BASE_PATH + `/schedule-reports/${id}`, val, headers);
    }

    getDynamicColumn(reportId): Observable<any> {
        let headers = { headers: { 'user_id': this.userInfoService.userDetails.userId, 'Accept-Version': 'V2' } };
        let apiUrl = environment.API_BASE_PATH + `/reports/${reportId}/dynamic-columns`;
        return this.commonService.getCall(apiUrl, headers);
        // return this.http.get('assets/dummyChargerReportColumn.json')
    }

    updateDynamicColumns(data, reportId) {
        let headers = { headers: { 'user_id': this.userInfoService.userDetails.userId, 'Accept-Version': 'V2' } };
        let apiUrl = environment.API_BASE_PATH + `/reports/${reportId}/dynamic-columns`;
        return this.commonService.postCall(apiUrl, data, headers)
    }


}